import { AES, enc } from 'crypto-ts';
import { CONFIG } from 'src/config-global';
import { PARAMS_KEY } from 'src/routes/BaseRoute';
// import { environment } from '@shared/environment/environment';
class EncryptUtils {
  static setEncryptedParams = (data: Record<string, string | undefined | number>): string =>
    encodeURIComponent(AES.encrypt(JSON.stringify(data), CONFIG.encryptDataKey).toString());

  static encryptedData = (data: Record<string, string | undefined | number>): string =>
    AES.encrypt(JSON.stringify(data), CONFIG.encryptDataKey).toString();

  static getDecryptedParams = (tokenString: string | null): Record<string, string | undefined> => {
    if (tokenString) {
      try {
        const dataString = AES.decrypt(decodeURIComponent(tokenString), CONFIG.encryptDataKey);
        return JSON.parse(dataString.toString(enc.Utf8));
      } catch (error) {
        console.error('Error during decryption:', error);
        return {};
      }
    }
    return {};
  };

  static decryptCipherString = (cipherString: string): Record<string, any> => {
    try {
      const decrypted = AES.decrypt(cipherString, CONFIG.encryptDataKey);
      return JSON.parse(decrypted.toString(enc.Utf8));
    } catch (error) {
      console.error('Error decrypting cipher string:', error);
      return {};
    }
  };

  static getDecryptedData = (location: any, paramKey: string): any => {
    const urlParam = new URLSearchParams(location).get(PARAMS_KEY);
    const paramsData = EncryptUtils.getDecryptedParams(urlParam);
    const value = paramsData?.[paramKey] || '';
    return value;
  };
}

export default EncryptUtils;
